import React from "react";
import Quality from "./Quality";

// Thin screen file — all logic lives in Quality.js; scope picks which rows show.
function QualityInspectionFG() {
  return <Quality scope="FG" />;
}

export default QualityInspectionFG;